module.exports = __webpack_public_path__ + "img/senior.932fe9b.png";